import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomPipesModule } from 'src/app/pipes/custom-pipes.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { HttpTranslateFactory } from 'src/app/helpers';
import { NgbCollapseModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { MatBadgeModule } from '@angular/material/badge';

import { ActionDropdownComponent } from './action-dropdown/action-dropdown.component';
import { ActionFormComponent } from './action-form/action-form.component';


@NgModule({
  declarations: [
    ActionDropdownComponent,
    ActionFormComponent,
  ],
  imports: [
    CommonModule,
    NgbCollapseModule, 
    NgbDropdownModule,
    MatBadgeModule,
    CustomPipesModule,
    TranslateModule.forChild({
      loader: {
        deps: [HttpClient],
        provide: TranslateLoader,
        useFactory: HttpTranslateFactory,
      },
    }),
  ],
  exports: [
    ActionFormComponent,
    ActionDropdownComponent,
  ]
})
export class ActionFormModule { }
